import {createContext} from "react";

export const TaskTypesContext = createContext([]);
export const MeasurementsContext = createContext({ idSize: 0, idComplexity: 0 });
